<template>
    <not-found-view v-if="error" :error500="true"></not-found-view>
    
    <template v-if="getVectaryModelListing !== null && !error">
        <div :class="['model', {'model--expanded': isModelExpanded || expanded}]">
            <button class="model__button model__button--expand" @click="expandModel">
                <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M20.7002 4.19995C20.3586 4.19995 20.0474 4.28554 19.8236 4.5093C19.5999 4.73306 19.5143 5.04433 19.5143 5.38589C19.5143 5.73811 19.5981 6.05796 19.8187 6.28913C20.0419 6.5229 20.355 6.61401 20.7002 6.61401H22.2962L17.1477 11.7626L17.1407 11.7707C16.9261 12.0183 16.7932 12.2962 16.7932 12.6C16.7932 12.9037 16.9261 13.1816 17.1407 13.4292L17.1477 13.4373L17.1553 13.4449C17.3839 13.6736 17.6729 13.7859 18.0002 13.7859C18.3275 13.7859 18.6165 13.6736 18.8451 13.4449L23.9861 8.3039V9.89995C23.9861 10.2452 24.0773 10.5583 24.311 10.7814C24.5422 11.0021 24.862 11.0859 25.2143 11.0859C25.5558 11.0859 25.8671 11.0003 26.0908 10.7765C26.3146 10.5528 26.4002 10.2415 26.4002 9.89995V5.38589C26.4002 5.05856 26.2879 4.76963 26.0592 4.54094C25.8305 4.31226 25.5416 4.19995 25.2143 4.19995H20.7002ZM13.4295 17.1404C13.1819 16.9259 12.9039 16.7929 12.6002 16.7929C12.2965 16.7929 12.0185 16.9259 11.7709 17.1404L11.7628 17.1474L6.61426 22.296V20.7C6.61426 20.3547 6.52314 20.0416 6.28937 19.8185C6.05821 19.5978 5.73836 19.514 5.38613 19.514C5.04458 19.514 4.73331 19.5996 4.50955 19.8234C4.28579 20.0471 4.2002 20.3584 4.2002 20.7V25.214C4.2002 25.5413 4.3125 25.8303 4.54119 26.059C4.76988 26.2876 5.0588 26.4 5.38613 26.4H9.9002C10.2418 26.4 10.553 26.3144 10.7768 26.0906C11.0005 25.8668 11.0861 25.5556 11.0861 25.214C11.0861 24.8618 11.0023 24.5419 10.7817 24.3108C10.5585 24.077 10.2454 23.9859 9.9002 23.9859H8.30415L13.4527 18.8373L13.4597 18.8292C13.6743 18.5816 13.8072 18.3037 13.8072 18C13.8072 17.6962 13.6743 17.4183 13.4597 17.1707L13.4457 17.1545L13.4295 17.1404ZM26.4002 20.7C26.4002 20.3584 26.3146 20.0471 26.0908 19.8234C25.8671 19.5996 25.5558 19.514 25.2143 19.514C24.862 19.514 24.5422 19.5978 24.311 19.8185C24.0773 20.0416 23.9861 20.3547 23.9861 20.7V22.296L18.8376 17.1474L18.8295 17.1404C18.5819 16.9259 18.3039 16.7929 18.0002 16.7929C17.6965 16.7929 17.4185 16.9259 17.1709 17.1404L17.1628 17.1474L17.1553 17.155C16.9266 17.3837 16.8143 17.6726 16.8143 18C16.8143 18.3273 16.9266 18.6162 17.1553 18.8449L22.2962 23.9859H20.7002C20.355 23.9859 20.0419 24.077 19.8187 24.3108C19.5981 24.5419 19.5143 24.8618 19.5143 25.214C19.5143 25.5556 19.5999 25.8668 19.8236 26.0906C20.0474 26.3144 20.3586 26.4 20.7002 26.4H25.2143C25.5416 26.4 25.8305 26.2876 26.0592 26.059C26.2879 25.8303 26.4002 25.5413 26.4002 25.214V20.7ZM13.4597 13.4292C13.6743 13.1816 13.8072 12.9037 13.8072 12.6C13.8072 12.2962 13.6743 12.0183 13.4597 11.7707L13.4527 11.7626L8.30415 6.61401H9.9002C10.2454 6.61401 10.5585 6.5229 10.7817 6.28912C11.0023 6.05796 11.0861 5.73811 11.0861 5.38589C11.0861 5.04433 11.0005 4.73306 10.7768 4.5093C10.553 4.28554 10.2418 4.19995 9.9002 4.19995H5.38614C5.0588 4.19995 4.76988 4.31225 4.54119 4.54094C4.3125 4.76963 4.2002 5.05855 4.2002 5.38589L4.2002 9.89995C4.2002 10.2415 4.28579 10.5528 4.50955 10.7765C4.73331 11.0003 5.04458 11.0859 5.38614 11.0859C5.73836 11.0859 6.05821 11.0021 6.28937 10.7814C6.52314 10.5583 6.61426 10.2452 6.61426 9.89995V8.3039L11.7628 13.4525L11.7709 13.4595C12.0185 13.6741 12.2965 13.807 12.6002 13.807C12.9039 13.807 13.1819 13.6741 13.4295 13.4595L13.4457 13.4454L13.4597 13.4292Z" fill="#FB6451"/>
                </svg>
            </button>

            <iframe
                :id="`${getVectaryModelListing.edges[0].node.modelId}`"
                :src="`https://www.vectary.com/viewer/v1/?model=${getVectaryModelListing.edges[0].node.modelId}`"
                frameborder="0"
                width="100%"
                height="100%"
                @load="initModel"
            >
            </iframe>

            <button class="model__button model__button--collapse" @click="collapseModel">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17.196 17.1952L24.4783 17.2032C24.7976 17.2032 25.1038 17.0763 25.3296 16.8505C25.5554 16.6248 25.6822 16.3186 25.6822 15.9993C25.6823 15.68 25.5555 15.3738 25.3297 15.1481C25.104 14.9223 24.7978 14.7955 24.4785 14.7955L17.1962 14.8045L17.2052 7.5222C17.2052 7.20292 17.0784 6.89673 16.8526 6.67098C16.6269 6.44524 16.3207 6.31843 16.0014 6.31845C15.6821 6.31847 15.3759 6.44533 15.1501 6.6711C14.9244 6.89688 14.7975 7.20309 14.7975 7.52237L14.8055 14.8047L7.52312 14.7967C7.36485 14.7961 7.20801 14.8268 7.06166 14.8871C6.9153 14.9474 6.78233 15.036 6.67041 15.148C6.55848 15.2599 6.46983 15.3928 6.40955 15.5392C6.34927 15.6856 6.31856 15.8424 6.3192 16.0007C6.31854 16.1589 6.34922 16.3158 6.40948 16.4621C6.46974 16.6085 6.55838 16.7414 6.67029 16.8533C6.78219 16.9652 6.91515 17.0539 7.0615 17.1141C7.20784 17.1744 7.36468 17.2051 7.52295 17.2044L14.8053 17.1954L14.7963 24.4778C14.7956 24.636 14.8263 24.7929 14.8866 24.9392C14.9468 25.0855 15.0355 25.2185 15.1474 25.3304C15.2593 25.4423 15.3922 25.531 15.5386 25.5912C15.6849 25.6515 15.8418 25.6822 16 25.6815C16.1583 25.6821 16.3151 25.6514 16.4615 25.5912C16.6078 25.5309 16.7408 25.4422 16.8527 25.3303C16.9647 25.2184 17.0533 25.0854 17.1136 24.939C17.1739 24.7927 17.2046 24.6359 17.204 24.4776L17.196 17.1952Z" fill="#1A1A1A"/>
                </svg>
            </button>
        </div>
    </template>
</template>

<script>
import { getVectaryModelListing } from '@/queries/vectaryModelQueries.js';

export default {
    name: 'HouseModel',
    props: ['expanded'],
    emits: ['close-model'],
    data() {
        return {
            error: false,
            getVectaryModelListing: null,
            isModelExpanded: false
        }
    },
    apollo: {
        getVectaryModelListing: {
            query: getVectaryModelListing,
            error(error) {
                console.log('errors', error);
                this.error = true;
            }
        },
    },
    computed: {
        vectaryModel() {
            return this.$store.getters['game/getVectaryModel'];
        },
        savedMaterials() {
            return this.$store.getters['game/getSavedMaterials'];
        },
    },
    methods: {
        async init(model) {
            function errHandler(err) {
                console.log('Vectary API error', err);
            }

            async function onReady() {
                try {
                    window.vctrModel = viewerApi;
                    console.log('Vectary API ready');
                } catch (e) {
                    errHandler(e);
                }
            }

            const viewerApi = new window.vctrApi(model, errHandler);

            try {
                await viewerApi.init();        
                onReady();
            } catch (e) {
                errHandler(e);
            }
        },
        async initModel() {
            this.$store.commit('game/saveVecataryModel', null);
            const init = this.init(`${this.getVectaryModelListing.edges[0].node.modelId}`);
            await init;
            this.$store.commit('game/saveVecataryModel', window.vctrModel);
        },
        expandModel() {
            this.isModelExpanded = true;
            document.body.classList.add('no-scroll');
        },
        collapseModel() {
            if (this.expanded) {
                this.$emit('close-model');
            } else {
                this.isModelExpanded = false;
                document.body.classList.remove('no-scroll');
            }
        },
        showVectaryObject(materialVectary) {
            let hasSpecialConditions = false;

            materialVectary.forEach(object => {
                if (object.relatedModel) {
                    this.savedMaterials.forEach(phase => {
                        if (phase.data) {
                            phase.data.forEach(material => {
                                if (material.uniqueId == object.relatedModel.id) {
                                    hasSpecialConditions = true;

                                    if (object.vectaryId && this.vectaryModel) {
                                        console.log("set visibility true for:", object.vectaryId);
                                        this.vectaryModel.setVisibility(object.vectaryId, true, false);
                                    }
                                }                            
                            });
                        }
                    });
                }
            });

            if (!hasSpecialConditions) {
                const object = materialVectary.filter(object => object.relatedModel == null);

                if (object[0].vectaryId && this.vectaryModel) {
                    console.log("set visibility true for:", object[0].vectaryId);
                    this.vectaryModel.setVisibility(object[0].vectaryId, true, false);
                }
            }
        }
    },
    watch: {
        vectaryModel() {
            if (this.vectaryModel) {
                this.vectaryModel.setVisibility('Camera', true, true);
                this.vectaryModel.getObjects().then((res) => {
                    console.log('all vectary objects that were accessed via api:', res)

                    if (this.savedMaterials.length) {
                        this.savedMaterials.forEach(phase => {
                            if (phase.data.length) {
                                phase.data.forEach(material => {
                                    this.showVectaryObject(material.buidlingVectaryModel);
                                });
                            }
                        });
                    }
                });
            }
        }
    }
}
</script>
